import React from 'react';
import StaffDashboardPage from './StaffDashboardPage';

const ReportingManagerLandingPage = () => {
  // Simply render the StaffDashboardPage with manager mode enabled
  // This will show tabs for manager-specific features
  return <StaffDashboardPage isManager={true} />;

};

export default ReportingManagerLandingPage;
